import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import InheritedHomeMortgage from "@/pages/tools/InheritedHomeMortgage";

export const Route = createFileRoute("/tools/inherited-home-mortgage")({
  head: () => seoHead("/tools/inherited-home-mortgage"),
  component: InheritedHomeMortgage,
});